import { createSlice } from "@reduxjs/toolkit";
import { getAllWholesalerBanner, getAllWholesalerBannerWithoughtId, getBannerById, getbannerList } from "./ThunkAction";
import { iBannerState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iBannerState = {
  isLoading: false,
  bannerDetail: null, // Ensure this is a single object
  bannerList:[],
  errorMessage: null,
  wholesalerBanner:[],
  wholesalerBannerById:[]
};
export const bannerSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetBannerState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannerById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBannerById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.bannerDetail = payload.data.banner;
          state.isLoading = false;
        }
      })
      .addCase(getBannerById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Banner data";
        state.isLoading = false;
      })
      .addCase(getbannerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getbannerList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.bannerList = payload.data.banners; 
          state.isLoading = false;
        }
      })
      .addCase(getbannerList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Banner data";
        state.isLoading = false;
      })

      //get wholesaler banner list
      .addCase(getAllWholesalerBanner.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWholesalerBanner.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.wholesalerBannerById = payload.data.banners; 
          state.isLoading = false;
        }
      })
      .addCase(getAllWholesalerBanner.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Banner data";
        state.isLoading = false;
      })

		  
      //get wholesaler banner getAllWholesalerBannerWithoughtId
      .addCase(getAllWholesalerBannerWithoughtId.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllWholesalerBannerWithoughtId.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.wholesalerBanner = payload.data.banners; 
          state.isLoading = false;
        }
      })
      .addCase(getAllWholesalerBannerWithoughtId.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Banner data";
        state.isLoading = false;
      });

       
  },
});

export const { resetBannerState } = bannerSlice.actions;
export default bannerSlice.reducer;
